// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';



const { Entry } = initSchema(schema);

export {
  Entry
};